import actionsModule from './actions/actions.module';
import filtersModule from './filters/filters.module';
import servicesModule from './services/services.module';

export default angular.module('fizyweb.paycell.common', [
  filtersModule,
  servicesModule,
  actionsModule
]).name;



// WEBPACK FOOTER //
// src/app/common/common.module.ts